export const isoToFaName: { [key: string]: string } = {
  AF: 'افغانستان',
  AL: 'آلبانی',
  DZ: 'الجزایر',
  AS: 'ساموآی آمریکا',
  AD: 'آندورا',
  AO: 'آنگولا',
  AI: 'آنگویلا',
  AQ: 'جنوبگان',
  AG: 'آنتیگوا و باربودا',
  AR: 'آرژانتین',
  AM: 'ارمنستان',
  AW: 'آروبا',
  AU: 'استرالیا',
  AT: 'اتریش',
  AZ: 'آذربایجان',
  AX: 'جزایر آلاند',
  BS: 'باهاما',
  BH: 'بحرین',
  BD: 'بنگلادش',
  BB: 'باربادوس',
  BY: 'بلاروس',
  BE: 'بلژیک',
  BZ: 'بلیز',
  BJ: 'بنین',
  BM: 'برمودا',
  BT: 'بوتان',
  BO: 'بولیوی',
  BA: 'بوسنی و هرزگوین',
  BW: 'بوتسوانا',
  BR: 'برزیل',
  IO: 'قلمرو بریتانیا در اقیانوس هند',
  BN: 'برونئی',
  BG: 'بلغارستان',
  BF: 'بورکینافاسو',
  BQ: 'بونیر، سنت یوستیشس و سابا',
  BI: 'بوروندی',
  BV: 'جزیرهٔ بووه',
  CV: 'کیپ ورد',
  KH: 'کامبوج',
  CM: 'کامرون',
  CA: 'کانادا',
  KY: 'جزایر کیمن',
  CF: 'جمهوری آفریقای مرکزی',
  TD: 'چاد',
  CL: 'شیلی',
  CN: 'چین',
  CX: 'جزیره کریسمس',
  CC: 'جزایر کوکوس',
  CO: 'کلمبیا',
  KM: 'کومور',
  CG: 'کنگو',
  CD: 'جمهوری دموکراتیک کنگو',
  CK: 'جزایر کوک',
  CR: 'کاستاریکا',
  CI: 'ساحل عاج',
  HR: 'کرواسی',
  CU: 'کوبا',
  CW: 'کوراسائو',
  CY: 'قبرس',
  CZ: 'جمهوری چک',
  DK: 'دانمارک',
  DJ: 'جیبوتی',
  DM: 'دومینیکا',
  DO: 'جمهوری دومینیکن',
  EC: 'اکوادور',
  EG: 'مصر',
  SV: 'السالوادور',
  GQ: 'گینه استوایی',
  ER: 'اریتره',
  EE: 'استونی',
  SZ: 'اسواتینی',
  ET: 'اتیوپی',
  FK: 'جزایر فالکلند',
  FO: 'جزایر فارو',
  FJ: 'فیجی',
  FI: 'فنلاند',
  FR: 'فرانسه',
  GF: 'گویان فرانسه',
  PF: 'پلی‌نزی فرانسه',
  TF: 'سرزمین‌های جنوبی فرانسه',
  GA: 'گابن',
  GM: 'گامبیا',
  GE: 'گرجستان',
  DE: 'آلمان',
  GH: 'غنا',
  GI: 'جبل‌الطارق',
  GR: 'یونان',
  GL: 'گرینلند',
  GD: 'گرنادا',
  GP: 'گوادلوپ',
  GU: 'گوآم',
  GT: 'گواتمالا',
  GG: 'گرنزی',
  GN: 'گینه',
  GW: 'گینه بیسائو',
  GY: 'گویان',
  HT: 'هائیتی',
  HM: 'جزایر هرد و مک‌دونالد',
  VA: 'واتیکان',
  HN: 'هندوراس',
  HK: 'هنگ کنگ',
  HU: 'مجارستان',
  IS: 'ایسلند',
  IN: 'هند',
  ID: 'اندونزی',
  IR: 'ایران',
  IQ: 'عراق',
  IE: 'ایرلند',
  IM: 'جزیره من',
  IL: 'اسرائیل',
  IT: 'ایتالیا',
  JM: 'جامائیکا',
  JP: 'ژاپن',
  JE: 'جرزی',
  JO: 'اردن',
  KZ: 'قزاقستان',
  KE: 'کنیا',
  KI: 'کیریباتی',
  KP: 'کره شمالی',
  KR: 'کره جنوبی',
  KW: 'کویت',
  KG: 'قرقیزستان',
  LA: 'لائوس',
  LV: 'لتونی',
  LB: 'لبنان',
  LS: 'لسوتو',
  LR: 'لیبریا',
  LY: 'لیبی',
  LI: 'لیختن‌اشتاین',
  LT: 'لیتوانی',
  LU: 'لوکزامبورگ',
  MO: 'ماکائو',
  MG: 'ماداگاسکار',
  MW: 'مالاوی',
  MY: 'مالزی',
  MV: 'مالدیو',
  ML: 'مالی',
  MT: 'مالت',
  MH: 'جزایر مارشال',
  MQ: 'مارتینیک',
  MR: 'موریتانی',
  MU: 'موریس',
  YT: 'مایوت',
  MX: 'مکزیک',
  FM: 'میکرونزی',
  MD: 'مولداوی',
  MC: 'موناکو',
  MN: 'مغولستان',
  ME: 'مونته‌نگرو',
  MS: 'مونتسرات',
  MA: 'مراکش',
  MZ: 'موزامبیک',
  MM: 'میانمار',
  NA: 'نامیبیا',
  NR: 'نائورو',
  NP: 'نپال',
  NL: 'هلند',
  NC: 'کالدونیای جدید',
  NZ: 'نیوزیلند',
  NI: 'نیکاراگوئه',
  NE: 'نیجر',
  NG: 'نیجریه',
  NU: 'نیوئه',
  NF: 'جزیره نورفک',
  MK: 'مقدونیه شمالی',
  MP: 'جزایر ماریانای شمالی',
  NO: 'نروژ',
  OM: 'عمان',
  PK: 'پاکستان',
  PW: 'پالائو',
  PS: 'فلسطین',
  PA: 'پاناما',
  PG: 'پاپوآ گینه نو',
  PY: 'پاراگوئه',
  PE: 'پرو',
  PH: 'فیلیپین',
  PN: 'پیتکرن',
  PL: 'لهستان',
  PT: 'پرتغال',
  PR: 'پورتوریکو',
  QA: 'قطر',
  RE: 'رئونیون',
  RO: 'رومانی',
  RU: 'روسیه',
  RW: 'رواندا',
  BL: 'سن بارتلمی',
  SH: 'سنت هلنا',
  KN: 'سنت کیتس و نویس',
  LC: 'سنت لوسیا',
  MF: 'سنت مارتن',
  PM: 'سن پیر و میکلن',
  VC: 'سنت وینسنت و گرنادین‌ها',
  WS: 'ساموآ',
  SM: 'سن مارینو',
  ST: 'سائوتومه و پرینسیپ',
  SA: 'عربستان سعودی',
  SN: 'سنگال',
  RS: 'صربستان',
  SC: 'سیشل',
  SL: 'سیرالئون',
  SG: 'سنگاپور',
  SX: 'سینت مارتن',
  SK: 'اسلواکی',
  SI: 'اسلوونی',
  SB: 'جزایر سلیمان',
  SO: 'سومالی',
  ZA: 'آفریقای جنوبی',
  GS: 'جزایر جورجیای جنوبی',
  SS: 'سودان جنوبی',
  ES: 'اسپانیا',
  LK: 'سری‌لانکا',
  SD: 'سودان',
  SR: 'سورینام',
  SJ: 'سوالبارد و یان ماین',
  SE: 'سوئد',
  CH: 'سوئیس',
  SY: 'سوریه',
  TW: 'تایوان',
  TJ: 'تاجیکستان',
  TZ: 'تانزانیا',
  TH: 'تایلند',
  TL: 'تیمور شرقی',
  TG: 'توگو',
  TK: 'توکلائو',
  TO: 'تونگا',
  TT: 'ترینیداد و توباگو',
  TN: 'تونس',
  TR: 'ترکیه',
  TM: 'ترکمنستان',
  TC: 'جزایر ترک و کایکوس',
  TV: 'تووالو',
  UG: 'اوگاندا',
  UA: 'اوکراین',
  AE: 'امارات متحده عربی',
  GB: 'بریتانیا',
  US: 'ایالات متحده آمریکا',
  UM: 'جزایر کوچک حاشیه‌ای ایالات متحده',
  UY: 'اروگوئه',
  UZ: 'ازبکستان',
  VU: 'وانواتو',
  VE: 'ونزوئلا',
  VN: 'ویتنام',
  VG: 'جزایر ویرجین بریتانیا',
  VI: 'جزایر ویرجین آمریکا',
  WF: 'والیس و فوتونا',
  EH: 'صحرای غربی',
  YE: 'یمن',
  ZM: 'زامبیا',
  ZW: 'زیمبابوه',
}
